/** Persist the right-panel photos tray album selection (survives refresh). Cleared on logout via `clearAuth`. */
export const PHOTOS_TRAY_ALBUM_STORAGE_KEY = 'photos-tray-album.v1'

export function readStoredPhotosTrayAlbum(): string | null {
  if (typeof window === 'undefined') return null

  try {
    const raw = localStorage.getItem(PHOTOS_TRAY_ALBUM_STORAGE_KEY)

    if (raw == null || raw === '') return null

    const value = JSON.parse(raw) as unknown

    if (typeof value !== 'string' || !value.trim()) return null

    return value
  } catch {
    return null
  }
}

export function writeStoredPhotosTrayAlbum(value: string): void {
  if (typeof window === 'undefined') return

  try {
    if (!value.trim()) return

    localStorage.setItem(PHOTOS_TRAY_ALBUM_STORAGE_KEY, JSON.stringify(value))
  } catch {
    // Quota / private mode — ignore.
  }
}

export function clearStoredPhotosTrayAlbum(): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(PHOTOS_TRAY_ALBUM_STORAGE_KEY)
  } catch {
    // ignore
  }
}
